import { useAuth } from "../../contexts/AuthContext";
import React, { useState, useEffect } from "react";
import { Drawer, List, ListItemButton, ListItemText, Typography, Collapse, Box, Avatar, Button, Tooltip, IconButton, useMediaQuery, useTheme, } from "@mui/material";
import { ExpandLess, ExpandMore, Dashboard as DashboardIcon, AddCircleOutline as ExpenseIcon, ReceiptLong as ExpenseFormIcon, Chat as ConversationalAIIcon, AddPhotoAlternate as UploadImageIcon, Autorenew as RecurringIcon, Menu as MenuIcon, ShoppingBag, } from "@mui/icons-material";
import SettingsIcon from "@mui/icons-material/Settings";
// import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useNavigate } from "react-router-dom";
import { getSharedWithMeExpenses } from "../ShareExpense/ShareExpenseAPI";
import GroupIcon from "@mui/icons-material/Group";

const SideBar = ({ currentPage }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [hasSharedExpenses, setHasSharedExpenses] = useState(false);
  const navigate = useNavigate();
  const { user, logout, getUserId } = useAuth();
  const userId = getUserId();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleNavigation = (page) => {
    navigate(`/${page}`);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  useEffect(() => {
    const checkSharedExpenses = async () => {
      const userId = getUserId?.();
      try {
        const result = await getSharedWithMeExpenses(userId);
        const list = Array.isArray(result) ? result : result?.data || [];
        setHasSharedExpenses(list.length > 0);
      } catch (err) {
        console.error("Failed to check shared expenses:", err);
        setHasSharedExpenses(false);
      }
    };
    checkSharedExpenses();
  }, [user]);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const drawerContent = (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.8rem",
          position: "relative",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src="/images/Guawwa.png"
            alt="Guawwa Logo"
            style={{
              width: "64px",
              height: "64px",
              objectFit: "contain",
            }}
          />

          <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
            <Typography
              variant="h6"
              sx={{
                color: "#58FF71",
                fontWeight: 200,
                fontSize: "2rem",
                lineHeight: 1,
                mt: 0.3,
              }}
            >
              GU<span style={{ borderRadius: "8px", color: "#58FF71", fontWeight: 800, letterSpacing: "-0.2rem" }}>AWW</span>A
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#d1d5db",
                fontSize: "0.9rem",
                lineHeight: 1.2,
                mt: 0.8,
              }}
            >
              Paperless. Effortless. Always.
            </Typography>
          </Box>
        </Box>
      </Box>

      <List disablePadding sx={{ margin: "0.8rem", flexGrow: 1 }}>
        <Tooltip title="Dashboard" placement="right">
          <ListItemButton
            selected={currentPage === "dashboard"}
            onClick={() => handleNavigation("dashboard")}
            sx={{
              borderRadius: 1,
              "&.Mui-selected": {
                backgroundColor: "#43b7e9ff",
                color: "white",
              },
              "&:hover": { backgroundColor: "#374151" },
            }}
          >
            <DashboardIcon sx={{ marginRight: 2 }} />
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                fontSize: "1rem",
              }}
            />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Add an Expense" placement="right">
          <ListItemButton
            onClick={() => setShowSubMenu(!showSubMenu)}
            sx={{
              borderRadius: 1,
              "&:hover": { backgroundColor: "#374151" },
            }}
          >
            <ExpenseIcon sx={{ marginRight: 2 }} />
            <ListItemText
              primary="Add an Expense"
              primaryTypographyProps={{
                fontSize: "1rem",
              }}
            />
            {showSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </Tooltip>

        <Collapse in={showSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 6 }}>
            <ListItemButton
              selected={currentPage === "expense-form"}
              onClick={() => handleNavigation("expense-form")}
              sx={{
                borderRadius: 1,
                fontSize: "0.9rem",
                color: "#d1d5db",
                "&.Mui-selected": {
                  backgroundColor: "#0ea5e9",
                  color: "#fff",
                  fontWeight: 500,
                },
                "&:hover": {
                  backgroundColor: "#374151",
                  color: "white",
                },
              }}
            >
              <ExpenseFormIcon sx={{ marginRight: 1 }} />
              <ListItemText
                primary="Enter Manually"
                primaryTypographyProps={{
                  fontSize: "0.9rem",
                  fontWeight: 200,
                }}
              />
            </ListItemButton>

            <ListItemButton
              selected={currentPage === "uploadImage"}
              onClick={() => handleNavigation("uploadImage")}
              sx={{
                borderRadius: 1,
                fontSize: "0.9rem",
                color: "#d1d5db",
                "&.Mui-selected": {
                  backgroundColor: "#0ea5e9",
                  color: "#fff",
                  fontWeight: 500,
                },
                "&:hover": {
                  backgroundColor: "#374151",
                  color: "white",
                },
              }}
            >
              <UploadImageIcon sx={{ marginRight: 1 }} />
              <ListItemText
                primary="Upload PDF / Images"
                primaryTypographyProps={{
                  fontSize: "0.9rem",
                  fontWeight: 200,
                }}
              />
            </ListItemButton>

            <ListItemButton
              selected={currentPage === "conversational-ai"}
              onClick={() => handleNavigation("conversational-ai")}
              sx={{
                borderRadius: 1,
                fontSize: "0.9rem",
                color: "#d1d5db",
                "&.Mui-selected": {
                  backgroundColor: "#0ea5e9",
                  color: "#fff",
                  fontWeight: 500,
                },
                "&:hover": {
                  backgroundColor: "#374151",
                  color: "white",
                },
              }}
            >
              <ConversationalAIIcon sx={{ marginRight: 1 }} />
              <ListItemText
                primary="Conversational AI"
                primaryTypographyProps={{
                  fontSize: "0.9rem",
                  fontWeight: 200,
                }}
              />
            </ListItemButton>
          </List>
        </Collapse>

        <Tooltip title="Recurring Expenses" placement="right">
          <ListItemButton
            selected={currentPage === "recurringExpenses"}
            onClick={() => handleNavigation("recurringExpenses")}
            sx={{
              borderRadius: 1,
              "&.Mui-selected": {
                backgroundColor: "#43b7e9ff",
                color: "white",
              },
              "&:hover": { backgroundColor: "#374151" },
            }}
          >
            <RecurringIcon sx={{ marginRight: 2 }} />
            <ListItemText
              primary="Recurring Expenses"
              primaryTypographyProps={{
                fontSize: "1rem",
              }}
            />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Return Items" placement="right">
          <ListItemButton
            selected={currentPage === "returnItems"}
            onClick={() => navigate("/returnItems")}
            sx={{
              borderRadius: 1,
              "&.Mui-selected": {
                backgroundColor: "#43b7e9ff",
                color: "white",
              },
              "&:hover": { backgroundColor: "#374151" },
            }}
          >
            <ShoppingBag sx={{ marginRight: 2 }} />
            <ListItemText
              primary="Return Items"
              primaryTypographyProps={{
                fontSize: "1rem",
              }}
            />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Stores" placement="right">
          <ListItemButton
            selected={currentPage === "restaurantMenu"}
            onClick={() => handleNavigation("restaurantMenu")}
            sx={{
              borderRadius: 1,
              "&.Mui-selected": {
                backgroundColor: "#43b7e9ff",
                color: "white",
              },
              "&:hover": { backgroundColor: "#374151" },
            }}
          >
            <StorefrontIcon sx={{ marginRight: 2 }} />
            <ListItemText
              primary="Stores"
              primaryTypographyProps={{
                fontSize: "1rem",
              }}
            />
          </ListItemButton>
        </Tooltip>
        {hasSharedExpenses && (
          <Tooltip title="Shared Expenses" placement="right">
            <ListItemButton
              selected={currentPage === "sharedExpenses"}
              onClick={() => handleNavigation("sharedExpenses")}
              sx={{
                borderRadius: 1,
                "&.Mui-selected": {
                  backgroundColor: "#43b7e9ff",
                  color: "white",
                },
                "&:hover": { backgroundColor: "#374151" },
              }}
            >
              <GroupIcon sx={{ marginRight: 2 }} />
              <ListItemText
                primary="Shared Expenses"
                primaryTypographyProps={{
                  fontSize: "1rem",
                }}
              />
            </ListItemButton>
          </Tooltip>
        )}
      </List>

      <Box
        sx={{
          p: 2,
          borderTop: "1px solid rgba(255,255,255,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "rgba(0,0,0,0.1)",
          gap: 1,
        }}
      >
        {user ? (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                sx={{
                  bgcolor: "#315EE0",
                  cursor: "pointer",
                  width: 32,
                  height: 32,
                  fontSize: "1rem",
                }}
              >
                {user?.firstName?.charAt(0).toUpperCase()}
              </Avatar>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, color: "white" }}
              >
                {user?.firstName} {user?.lastName}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
              <IconButton
                size="small"
                onClick={() => navigate("/settings")}
                sx={{
                  color: "white",
                  "&:hover": { color: "#38BDF8" },
                  p: 0.5,
                  mr: 0.8,
                }}
              >
                <SettingsIcon />
              </IconButton>
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  logout();
                  navigate("/login");
                }}
                sx={{
                  backgroundColor: "#ef4444",
                  "&:hover": { backgroundColor: "#dc2626" },
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  minWidth: "64px",
                }}
              >
                Logout
              </Button>
            </Box>
          </>
        ) : (
          <Button
            variant="contained"
            onClick={() => handleNavigation("login")}
            sx={{
              backgroundColor: "#38BDF8",
              "&:hover": { backgroundColor: "#38BDF8" },
              borderRadius: "15px",
              fontSize: "1rem",
              padding: "5px 15px",
            }}
          >
            Login
          </Button>
        )}
      </Box>
    </>
  );

  return (
    <>
      {isMobile && (
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
            position: "fixed",
            top: 16,
            left: 16,
            zIndex: 1300,
            color: "white",
            backgroundColor: "#5339c7",
            "&:hover": { backgroundColor: "#803abd" },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              width: 280,
              boxSizing: 'border-box',
              background: " linear-gradient(135deg, #4a08c1 0%, #5e12c0 40%, #9e24be 75%, #b92ab8 100%)",
              color: "white",
              boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
            },
          }}
        >
          {drawerContent}
        </Drawer>
      ) : (
        <Drawer
          variant="persistent"
          open={true}
          sx={{
            width: "26%",
            flexShrink: 0,
            display: { xs: 'none', md: 'block' },
            "& .MuiDrawer-paper": {
              width: "26%",
              boxSizing: "border-box",
              background: "linear-gradient(135deg, #4a08c1 0%, #5e12c0 40%, #9e24be 75%, #b92ab8 100%)",
              color: "white",
              borderRadius: "20px",
              margin: "2.2rem",
              height: "calc(100% - 70px)",
              boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}
    </>
  );
};

export default SideBar;
